// generated from 24 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const firstPurchaseByAppFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("first_purchase_by_app_filter"),
  comparison_key: z.enum([
    "3", // 21 (87.50%)
    "4", // 3 (12.50%)
  ]),
  display_name: z.object({
    // undefined: 20 (83.33%), defined 4 (16.67%)
    deleted_app: z.literal(true).optional(),
    id: common.objectId,
    value: z.string(),
  }),
  // undefined: 10 (41.67%), defined 14 (58.33%)
  raw_value: z
    .union([
      // number samples: 1 (7.14%)
      z.literal(1000),
      // string samples: 13 (92.86%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 3 (12.50%)
    // integer: 2 (66.67%)
    // avg: 336.14, min: 0.41666666666666663, max: 1000
    z.number().nonnegative(),
    // string samples: 21 (87.50%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
